var availCheckFormSimple = vueIfExists({
	mixins: [win.buttonSpinner, win.availCheckMixin],
	el: '#avail-check-form-container-simple',
	data: {
		rooms: [],
		sharedState: store.state,
		calendars: {}
	},
	methods: {
        submit: function(event) {
        	event.preventDefault();
        	this.startBtnLoader(event.target);
        	this.rooms = win.availCheckForm.rooms;
			$d.scrollto({ distance: win.isMobile ? 0 : -gE('header-hotel-fixed').offsetHeight || -65, toElement: qS('.avail-check-wrapper')});
        	this.storeQueryObj({
        		failed: function(errorType) {
   			 		this.stopBtnLoader(event.target);
   			 		win.rooms.visible = false;
        		},
        		success: function(roomQuery) {
		        	win.rooms.getRooms({
		        		query: roomQuery,
		        		scope: this,
		        		callback: function() {
		        			this.stopBtnLoader();
		        			var $target;
		        			if (this.sharedState.errorType == null) {
		        				$target = win.rooms.$el;
		        			} else {
		        				$target = win.availCheckForm.$el;	
		        			}
		        		}
		        	});
        		}
        	});
        },
    }
});

